var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.4 249.1",
    style: {
      enableBackground: "new 0 0 249.4 249.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,250.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1092.3,2493.4c-538-73-971-478-1070-1001c-62-330,6-661,195-944c66-98,231-264,326-327c145-95,293-157,464-194 c118-25,362-25,480,0c244,52,441,154,615,318c184,175,306,387,360,626c94,414-21,835-312,1144c-171,180-419,317-665,364 C1382.3,2499.4,1185.3,2506.4,1092.3,2493.4z M1372.3,2394.4c297-34,578-186,761-412c118-147,186-283,231-468c22-88,26-128,27-250 c0-174-18-281-75-425c-301-773-1296-982-1879-395c-329,330-426,810-251,1243c89,223,275,438,481,555 C892.3,2371.4,1126.3,2421.4,1372.3,2394.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,1548.4c-130-47-213-208-183-358c15-75,32-110,79-159c62-67,102-82,211-82c87,0,100,3,148,29c89,50,138,129,149,241 c14,154-75,298-206,335C587.3,1568.4,489.3,1565.4,440.3,1548.4z M659.3,1423.4c59-43,89-142,68-229c-40-168-261-201-337-50 c-46,90-22,231,48,280C496.3,1466.4,599.3,1465.4,659.3,1423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.3,1544.4c-188-75-241-352-99-520c77-92,259-109,340-31l22,21l3-28c3-25,6-27,53-27h50l3,158l3,157h-141h-140v-50v-50 h85c92,0,95-2,69-56c-18-37-82-74-130-74c-115,0-184,81-184,212c1,145,94,228,221,198c49-12,99-55,99-86c0-10,15-14,60-14h59 l-14,45c-31,105-108,158-235,162C1861.3,1563.4,1830.3,1559.4,1793.3,1544.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.3,1254.4v-300h50h50l2,202l3,203l74-203l74-203l50,3l50,3l73,200l73,200l3-200l3-200l53-3l52-3l-2,298l-3,298h-69h-70 l-80-222c-44-123-83-220-86-215c-4,4-40,99-80,212s-78,211-83,218c-6,7-34,12-73,12h-64V1254.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmg);
export default __webpack_public_path__ + "static/media/OMG.18f416ce11297dd702195f8fe1574bc4.svg";
export { ForwardRef as ReactComponent };